import { memo } from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IOffer } from 'modules/sales-offer/offer/interfaces';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';

type Props = {
  data?: IOffer;
};

const OfferScopeChip = ({ data }: Props) => {
  const { t } = useTranslation('offerOrder');

  if (data?.isGlobal === false && data?.distributionCenter) {
    return (
      <AvatarNameCell
        name={data.distributionCenter.name}
        hideImage
        link={`/inventory/distribution-centers/${data.distributionCenter._id}/general`}
      />
    );
  }

  return <Chip size='small' label={t('scope.globalChip')} color='default' variant='outlined' />;
};

export default memo(OfferScopeChip);
